import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNotificationsColored = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M19.9995 31C21.237 31 22.2495 29.9846 22.2495 28.7436H17.7495C17.7495 29.342 17.9866 29.916 18.4085 30.3391C18.8305 30.7623 19.4028 31 19.9995 31ZM26.7495 24.2308V18.5897C26.7495 15.1262 24.9045 12.2267 21.687 11.4595V10.6923C21.687 9.7559 20.9333 9 19.9995 9C19.0658 9 18.312 9.7559 18.312 10.6923V11.4595C15.0833 12.2267 13.2495 15.1149 13.2495 18.5897V24.2308L10.9995 26.4872V27.6154H28.9995V26.4872L26.7495 24.2308Z",
			fill: "url(#paint0_linear_320_31594)"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 24.9652,
			cy: 14.5,
			rx: 3.96569,
			ry: 4,
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_320_31594",
			x1: 10.9995,
			y1: 31,
			x2: 32.5639,
			y2: 13.3564,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#AC8EFF" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#51B7D8"
			})]
		}) })
	]
});
export default SvgNotificationsColored;
